import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPreview.css';

const services = [
  {
    title: 'Web & Software Development',
    description: 'Websites, applications, and business systems built around real operational needs.',
  },
  {
    title: 'E-commerce Development',
    description: 'Online stores and tailored commerce functionality designed for smoother selling.',
  },
  {
    title: 'Shopify Development',
    description: 'Shopify stores, themes, custom apps, and integrations shaped for your business.',
  },
  {
    title: 'API & Payment Integrations',
    description: 'Connected platforms and payment workflows that keep business systems working together.',
  },
  {
    title: 'AI & Business Automation',
    description: 'Practical automation for inquiries, follow-ups, bookings, and repetitive workflows.',
  },
];

function ServicesPreview() {
  return (
    <section className="services-preview">
      <div className="container">
        <div className="services-preview-header">
          <span>What we do</span>
          <h2>Technology Services for Growing Businesses</h2>
          <p>Focused expertise to build, connect, and improve the digital systems your business relies on.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <article className="service-item" key={service.title}>
              <span className="service-number">{String(index + 1).padStart(2, '0')}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
        <Link to="/services" className="services-preview-link">Explore All Services <span aria-hidden="true">→</span></Link>
      </div>
    </section>
  );
}

export default ServicesPreview;
